import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';
import { Toaster } from '../../components/ui/toaster';
import { Loader2, LogIn, KeyRound } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const nav = useNavigate();
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(username, password);
      nav('/admin');
    } catch (err) {
      toast({
        title: 'Error de acceso',
        description: err.response?.data?.detail || 'Credenciales incorrectas',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a1420] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]" style={{
        backgroundImage: 'linear-gradient(rgba(0,224,199,.6) 1px, transparent 1px), linear-gradient(90deg, rgba(0,224,199,.6) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} />
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#00e0c7]/10 blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-[#00a3ff]/10 blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="relative w-12 h-12 rounded-xl bg-gradient-to-br from-[#00e0c7] to-[#00a3ff] flex items-center justify-center">
              <div className="absolute inset-1 rounded-lg bg-[#0d1b2a] flex items-center justify-center">
                <span className="text-[#00e0c7] font-bold">LD</span>
              </div>
            </div>
          </div>
          <h1 className="font-display text-white text-3xl font-light">Panel de Administración</h1>
          <p className="text-white/40 text-sm mt-2">Laboratorio Digital de Cine</p>
        </div>

        <form onSubmit={submit} className="bg-white/[0.03] border border-white/8 rounded-3xl p-8 backdrop-blur-sm">
          <label className="block mb-5">
            <span className="block text-[11px] uppercase tracking-widest text-white/50 mb-2">Usuario</span>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="ldc-input"
              placeholder="admin"
              autoFocus
            />
          </label>
          <label className="block mb-7">
            <span className="block text-[11px] uppercase tracking-widest text-white/50 mb-2">Contraseña</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="ldc-input"
              placeholder="••••••••"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#00e0c7] hover:bg-[#00c4ad] text-[#0d1b2a] font-semibold inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-50"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            Acceder al panel
          </button>
          <p className="mt-6 text-center text-[12px] text-white/35">
            <KeyRound className="inline w-3 h-3 mr-1" />
            Credenciales iniciales: <span className="text-[#9be8dc]">admin / admin123</span>
          </p>
        </form>
      </div>

      <Toaster />
    </div>
  );
};

export default AdminLogin;
